import { render } from "./ManageTaskUsersModal.vue?vue&type=template&id=ed3f3572"
import script from "./ManageTaskUsersModal.vue?vue&type=script&lang=js"
export * from "./ManageTaskUsersModal.vue?vue&type=script&lang=js"

import "./ManageTaskUsersModal.vue?vue&type=style&index=0&id=ed3f3572&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__